import 'css-chunksrc/client/scenes/projectReport/styles.scss';export default {
  "projectReport": "_projectReport_1ob8e_1",
  "headerBackGround": "_headerBackGround_1ob8e_9",
  "header": "_header_1ob8e_9",
  "headerRight": "_headerRight_1ob8e_25",
  "projectRedirection": "_projectRedirection_1ob8e_33",
  "contentProjectRedirection": "_contentProjectRedirection_1ob8e_38",
  "contextualMenu": "_contextualMenu_1ob8e_44",
  "main": "_main_1ob8e_51",
  "form": "_form_1ob8e_62",
  "submissionDate": "_submissionDate_1ob8e_66",
  "row": "_row_1ob8e_71",
  "name": "_name_1ob8e_79",
  "author": "_author_1ob8e_85",
  "authorAvatar": "_authorAvatar_1ob8e_93",
  "authorName": "_authorName_1ob8e_101",
  "subTitle": "_subTitle_1ob8e_106",
  "input": "_input_1ob8e_112",
  "buttonBox": "_buttonBox_1ob8e_122",
  "button": "_button_1ob8e_122",
  "closeIconBox": "_closeIconBox_1ob8e_154",
  "closeIcon": "_closeIcon_1ob8e_154",
  "folderIcon": "_folderIcon_1ob8e_164",
  "projectName": "_projectName_1ob8e_170",
  "footer": "_footer_1ob8e_181",
  "downloadButton": "_downloadButton_1ob8e_190"
};